export function isTokenValid() {
    const token = localStorage.getItem("credential");
    if (!token) return false;

    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Math.floor(Date.now() / 1000);
        console.log("payload.exp > currentTime", payload.exp > currentTime);
        return payload.exp > currentTime;
    } catch (e) {
        console.log("Error Token", e);
        return false; // Invalid or corrupted token
    }
  }

  export function decodeJwt(token) {
    try {
      const base64Url = token.split('.')[1]; // payload part
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join('')
      );
  
      return JSON.parse(jsonPayload);
    } catch (e) {
      console.error('Invalid token:', e);
      return null;
    }
  }